import { render, staticRenderFns } from "./PatientAnnotations.vue?vue&type=template&id=18238a5a&"
import script from "./PatientAnnotations.vue?vue&type=script&lang=js&"
export * from "./PatientAnnotations.vue?vue&type=script&lang=js&"
import style0 from "./PatientAnnotations.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports